import { languageItem } from '@/language/helpers'
import { openModal } from '@/modals/helpers/api'
import MembershipModal from '@/modals/MembershipModal.vue'

export function openMembershipModal() {
  const t = languageItem('membershipModal')
  openModal({
    name: 'membership-modal',
    title: t.title,
    component: MembershipModal,
  })
}
